export const inserosale = {
  inesrosale_discrepancy_item_quantity_mismatch: `El artículo '{{0}} {{1}}' tiene una discrepancia en la cantidad '{{2}}' con la cantidad '{{4}}' del DN '{{3}}'.`,
};
